module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst fieldsConfig = fieldConfig.fields || {}\nconst additionalClasses = []\nif(fieldConfig.frameLess)       additionalClasses.push('frameLess');\nif(fieldsConfig.date.hidden)    additionalClasses.push('dateHidden');\nconst additionalAttributes = []\nif(additionalClasses.length > 0){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div data-field-code=\"<%= model.fieldCode %>\" <%- additionalAttributes.join(' ') %>>\n<% if(fieldsConfig.date.hidden !== true){ %>\n<%- include('./air-datetime-picker', { model: { dataDATE: model.dataDATE, fieldCode: \"date\", config: fieldsConfig.date || {}}}); %>\n<% } %>\n<%- include('./time-picker', { model: { dataTIME: model.time, fieldCode: \"time\", config: fieldsConfig.time || {}}}); %>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\form\\fields\\air-date-and-time-picker.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const fieldsConfig = fieldConfig.fields || {}
const additionalClasses = []
if(fieldConfig.frameLess)       additionalClasses.push('frameLess');
if(fieldsConfig.date.hidden)    additionalClasses.push('dateHidden');
const additionalAttributes = []
if(additionalClasses.length > 0){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 11
    ; __append("<div data-field-code=\"")
    ; __append(escapeFn( model.fieldCode ))
    ; __append("\" ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">\n")
    ; __line = 12
    ;  if(fieldsConfig.date.hidden !== true){ 
    ; __append("\n")
    ; __line = 13
    ; __append( include('./air-datetime-picker', { model: { dataDATE: model.dataDATE, fieldCode: "date", config: fieldsConfig.date || {}}}) )
    ; __append("\n")
    ; __line = 14
    ;  } 
    ; __append("\n")
    ; __line = 15
    ; __append( include('./time-picker', { model: { dataTIME: model.time, fieldCode: "time", config: fieldsConfig.time || {}}}) )
    ; __append("\n</div>")
    ; __line = 16
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\form\fields\air-date-and-time-picker.ejs

}